export const parseStreamChunk = <T>(inputString: string) =>
  inputString.split('\n').reduce((result, line) => {
    const trimmedLine = line.trim();

    if (!trimmedLine) {
      return result;
    }

    try {
      result.push(JSON.parse(trimmedLine));
    } catch {
      // A malformed line must not discard the lines that parsed cleanly, or one
      // bad record silently drops the rest of the stream.
    }

    return result;
  }, [] as T[]);
